import api from "./api";
import { Capacitor } from "@capacitor/core";

export default {
  async solicitarContraseña(cedula: number) {
    return api.get(`login?emp_cedula=${cedula}`);
  },

  async login(cedula: number, contraseña: string) {
    // origen: 'android'/'ios' (app instalada) o 'web' (navegador). Se guarda en el
    // historial de dispositivo seguro para poder distinguir app <-> navegador.
    const origen = Capacitor.getPlatform();
    const payload = { emp_cedula: cedula, emp_codigo: contraseña, origen };
    return api.post(`login`, payload);
  },

  async logout() {
    return api.post(`/logout`);
  },

  async me() {
    // Normalización centralizada de cargo en el frontend.
    // Objetivo: tratar "SUB GERENTE SERVICIOS ESPECIALIZADOS" como "GERENTE DE OPERACIONES"
    // para que el menú y las pantallas con comparaciones por string se comporten como Gerencia,
    // sin tener que modificar múltiples componentes.
    const response = await api.get("usuario/mi_informacion");

    const cargo = response?.data?.datos?.emp_cargo;
    if (cargo === "SUB GERENTE SERVICIOS ESPECIALIZADOS") {
      response.data.datos.emp_cargo = "GERENTE DE OPERACIONES";
    }

    return response;
  },
};
